module.exports = __webpack_public_path__ + "2e90d5152ce92858b62ba053c7b9d2cb.woff";